module.exports = __webpack_public_path__ + "rekord-mobile.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rekord-mobile.png
// module id = 1545
// module chunks = 0